/**
 * Resolve the API base URL at RUNTIME, not solely from the build-time env var.
 *
 * `REACT_APP_API_BASE_URL` is inlined into the bundle at build time by CRA. If a
 * production build picks up `.env.local` / `.env.development` (both point at
 * `http://localhost:8787`) — and CRA loads `.env.local` with HIGHER priority than
 * `.env.production` — the deployed site ends up calling localhost. That is
 * exactly how developer.vecros.com shipped a bundle hard-wired to localhost.
 *
 * Guard against it: when the page is NOT served from localhost, refuse a
 * localhost API and fall back to the deployed API host. This makes the correct
 * host survive a bad build. (Still fix the build so the right value bakes in —
 * see .env.production — this is defense in depth, not a substitute.)
 */

// Deployed API host. Matches REACT_APP_API_BASE_URL in .env.production; update
// here too if the production backend host ever changes.
const DEPLOYED_API_BASE = "https://prod-api.vecros.com";

const isLocalHost = (host) => host === "localhost" || host === "127.0.0.1" || host === "[::1]";

const looksLocal = (url) => /\/\/(localhost|127\.0\.0\.1|\[::1\])/i.test(url || "");

export function resolveApiBase() {
  const baked = process.env.REACT_APP_API_BASE_URL;
  const host = typeof window !== "undefined" ? window.location.hostname : "";

  if (isLocalHost(host)) {
    // Local dev: honour the baked value, defaulting to the local backend.
    return baked || "http://localhost:8787";
  }
  // Deployed: never talk to localhost even if it leaked into the build env.
  if (baked && !looksLocal(baked)) return baked;
  return DEPLOYED_API_BASE;
}

export const API_BASE = resolveApiBase();
